import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanContainerJournal = _resolveComponent("PlanContainerJournal")!

  return (_openBlock(), _createBlock(_component_PlanContainerJournal, {
    parentModel: _ctx.parentModel,
    isCalculation: _ctx.isCalculation,
    isSettingsOpen: _ctx.isSettingsOpen
  }, null, 8, ["parentModel", "isCalculation", "isSettingsOpen"]))
}